import type { DevEnv } from "../../../types/environment.ts";
import { awsRoleName } from "../aws/policy/shared.ts";

export const installSql = `
CREATE USER p0_iam_manager IDENTIFIED WITH AWSAuthenticationPlugin AS 'RDS';
GRANT CREATE USER, CREATE ROLE ON *.* TO p0_iam_manager;
GRANT ROLE_ADMIN ON *.* TO p0_iam_manager;
GRANT ALL PRIVILEGES ON \`%\`.* TO p0_iam_manager WITH GRANT OPTION;
`.trim();

export const installTf = (
  context: DevEnv,
  params: {
    connectorArn: string;
    connectorId?: string;
    id: string;
    type: "cluster" | "db";
  }
) => {
  const iamRole = awsRoleName(context, "iam-write");
  const dbTag = params.type === "cluster" ? "cluster" : "db_instance";
  const isConnectorInstalled = !!params.connectorId;
  return [
    `
data "aws_rds_${dbTag}" "database" {
  ${dbTag}_identifier = "${params.id}"
}
`.trim(),
    ...[
      isConnectorInstalled
        ? `
data "aws_lambda_function" "connector" {
  function_name = "${params.connectorId}"
}
`.trim()
        : `
data "aws_db_subnet_group" "database" {
  name = data.aws_rds_${dbTag}.database.db_subnet_group_name
}

module "aws_db_connector_install" {
  source  = "p0-security/p0-connector/aws"
  version = "0.2.1"

  aws_role_name = "${iamRole}"
  aws_services  = ["rds"]

  service            = "mysql"
  service_subnet_ids = data.aws_db_subnet_group.database.subnet_ids
  vpc_id             = data.aws_db_subnet_group.database.vpc_id

  connector_arn = "${params.connectorArn}"
}
        `.trim(),
    ],
    `
module "aws_mysql_install" {
  source  = "p0-security/p0-db/aws"
  version = "0.2.1"

  arch            = "mysql"
  rds_arn         = data.aws_rds_${dbTag}.database.arn

  connector_security_group_id = module.aws_db_connector_install.connector_security_group.id
  lambda_execution_role_name  = reverse(split("/", reverse(split(":", module.aws_db_connector_install.lambda.role))[0]))[0]
}
`.trim(),
  ]
    .join("\n\n")
    .trim();
};
